import React from 'react';
import styled from 'styled-components';

const OrangeHeadline = styled.div`
  font-weight: 500;
  font-size: 25px;
  color: #f39e6a;
`;
export default OrangeHeadline;
